"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxActions = require("redux-actions");

var _httpActions = require("../actions/http-actions");

var _util = require("./util");

var _servicingActions = require("../actions/servicing-actions");

var _handleActions;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var initialState = {
  loanStatusesByAssetId: {// 'a6d3c3d4-369a-11e8-b467-0ed5f89f718b': {
    //   borrowerId: '',
    //   assetId: '',
    //   nextDueDate: '',
    //   nextPaymentAmount: 0,
    //   monthlyPaymentAmount: 0,
    //   currentPrincipal: 0,
    //   originalPrincipal: 0,
    //   currentEscrow: 0,
    //   currentFees: 0,
    //   currentInterest: 0,
    //   totalOwed: 0,
    //   daysLate: 0,
    //   isPaymentDue: true,
    //   interestRate: 0,
    //   status: '',
    //   transferred: false,
    //   daysSinceTransfer: 0,
    //   originalTermMonths: 0,
    //   remainingTermMonths: 0,
    //   rateType: '',
    //   loanType: '',
    //   loanNumber: '',
    //   nextAutopayAmount: 0,
    //   nextAutopayDate: '',
    //   nextAutopayLocalDate: '',
    //   escrowSummary: {
    //     currentBalance: 0,
    //     currentPayment: 0,
    //     escrowDisabled: false,
    //     insurance: 0,
    //     taxes: 0,
    //   },
    //   profile: {
    //     autopayEnabled: true,
    //     autopayAmount: 0,
    //     autopayAccountUuid: '',
    //     disbursementAccountUuid: ''
    //   }
    //   achAccounts: [
    //     {
    //       uuid: '',
    //       autopayEnabled: true,
    //       accountType: 'CHECKING|SAVINGS',
    //       accountHolderName: '',
    //       accountNumber: '',
    //       routingNumber: ''
    //     }
    //   ],
    //   transactions: [
    //     {
    //       uuid: '',
    //       amount: 0,
    //       postDate: '',
    //       effectiveDate: '',
    //       type: '',
    //       typeDescription: '',
    //       message: ''
    //     }
    //   ],
    //   allocations: {},
    //   drawEligibility: {
    //     activeDrawFreezeTermination: false,
    //     assetId: '',
    //     borrowerId: '',
    //     borrowerWaivedEligibility: false,
    //     creditLimit: 0,
    //     cutoffDate: '',
    //     eligible: false,
    //     hasDrawTerms: false,
    //     inForbearance: false,
    //     interestRate: 0,
    //     isBelowMinDraw: false,
    //     isDelinquent: false,
    //     isPastDeadline: false,
    //     marginInterest: 0,
    //     maxDrawAmount: 0,
    //     meetsConsecutivePaymentsAfterForbearance: false,
    //     parentInterestRate: 0,
    //     parentPrimeRate: 0,
    //     paymentChangeDate: '',
    //     pendingDraw: false,
    //     primeRate: 0,
    //     profileChangeDate: '',
    //     projectEligible: false,
    //     projectMaxAmount: 0,
    //     remainingTermMonths: 0,
    //   },
    //   qualifiedPaymentsOnly: true,
    // }
  },
  activeUuid: '',
  error: '',
  loading: false
};
exports.initialState = initialState;

var autopayEnabledMapper = function autopayEnabledMapper(achAccount, profile) {
  // if disabled, they're all disabled
  if (!profile.autopayEnabled || !profile.autopayAccountUuid) return _objectSpread(_objectSpread({}, achAccount), {}, {
    autopayEnabled: false
  });
  return _objectSpread(_objectSpread({}, achAccount), {}, {
    autopayEnabled: profile.autopayAccountUuid === achAccount.uuid
  });
};

var reducer = (0, _reduxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _servicingActions.ACTIVATE_LOAN, function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return _objectSpread(_objectSpread({}, state), {}, {
    activeUuid: action.payload
  });
}), (0, _defineProperty2.default)(_handleActions, (0, _reduxActions.combineActions)("".concat(_servicingActions.GET_USER_LOAN_STATUSES, "_").concat(_httpActions.REQUEST), "".concat(_servicingActions.GET_LOAN_STATUS, "_").concat(_httpActions.REQUEST), "".concat(_servicingActions.GET_TRANSACTIONS, "_").concat(_httpActions.REQUEST), "".concat(_servicingActions.GET_ACH_ACCOUNTS, "_").concat(_httpActions.REQUEST)), function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  return _objectSpread(_objectSpread({}, state), {}, {
    error: '',
    loading: true
  });
}), (0, _defineProperty2.default)(_handleActions, (0, _reduxActions.combineActions)("".concat(_servicingActions.SAVE_ACH_ACCOUNT, "_").concat(_httpActions.REQUEST), "".concat(_servicingActions.SAVE_PAYMENT, "_").concat(_httpActions.REQUEST), "".concat(_servicingActions.DELETE_ACH_ACCOUNT, "_").concat(_httpActions.REQUEST)), function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  return _objectSpread(_objectSpread({}, state), {}, {
    error: ''
  });
}), (0, _defineProperty2.default)(_handleActions, (0, _reduxActions.combineActions)("".concat(_servicingActions.SAVE_ACH_ACCOUNT, "_").concat(_httpActions.FAILURE), "".concat(_servicingActions.SAVE_PAYMENT, "_").concat(_httpActions.FAILURE), "".concat(_servicingActions.UPDATE_AUTOPAY, "_").concat(_httpActions.FAILURE), "".concat(_servicingActions.DELETE_ACH_ACCOUNT, "_").concat(_httpActions.FAILURE)), function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    error: (0, _util.payloadError)(action)
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_servicingActions.GET_USER_LOAN_STATUSES, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  var loanStatusesByAssetId = action.payload.loans.map(function (l) {
    var loanStatus = state.loanStatusesByAssetId[l.assetId] || {};
    var _l$profile = l.profile,
        profile = _l$profile === void 0 ? {} : _l$profile,
        _l$escrowSummary = l.escrowSummary,
        escrowSummary = _l$escrowSummary === void 0 ? {} : _l$escrowSummary;
    return _objectSpread(_objectSpread({}, loanStatus), {}, {
      borrowerId: l.borrowerId,
      nextDueDate: l.nextDueDate,
      nextPaymentAmount: l.nextPaymentAmount,
      monthlyPaymentAmount: l.monthlyPaymentAmount,
      currentPrincipal: l.currentPrincipal,
      originalPrincipal: l.originalPrincipal,
      currentEscrow: l.currentEscrow,
      currentFees: l.currentFees,
      currentInterest: l.currentInterest,
      totalOwed: l.totalOwed,
      daysLate: l.daysLate,
      isPaymentDue: l.isPaymentDue,
      isPaymentAllowed: l.isPaymentAllowed,
      interestRate: l.interestRate,
      assetId: l.assetId,
      originalTermMonths: l.originalTermMonths,
      remainingTermMonths: l.remainingTermMonths,
      rateType: l.rateType,
      loanType: l.loanType,
      loanNumber: l.loanNumber,
      nextAutopayAmount: l.nextAutopayAmount,
      nextAutopayDate: l.nextAutopayDate,
      nextAutopayLocalDate: l.nextAutopayLocalDate,
      profile: _objectSpread(_objectSpread({}, loanStatus.profile), {}, {
        autopayEnabled: profile.autopayEnabled,
        autopayAmount: profile.autopayAmount,
        autopayAccountUuid: profile.autopayAccountUuid,
        disbursementAccountUuid: profile.disbursementAccountUuid
      }),
      escrowSummary: _objectSpread(_objectSpread({}, loanStatus.escrowSummary), {}, {
        currentBalance: escrowSummary.currentBalance,
        currentPayment: escrowSummary.currentPayment,
        escrowDisabled: escrowSummary.escrowDisabled,
        insurance: escrowSummary.insurance,
        taxes: escrowSummary.taxes
      }),
      achAccounts: (0, _util.mergeList)(loanStatus.achAccounts, l.achAccounts).map(function (a) {
        return autopayEnabledMapper(a, profile);
      }),
      status: l.status,
      transferred: l.status === 'TRANSFERRED',
      transferData: l.transferData,
      daysSinceTransfer: l.daysSinceTransfer,
      allocations: l.allocations,
      drawEligibility: l.drawEligibility,
      servicerName: l.servicerName,
      qualifiedPaymentsOnly: l.qualifiedPaymentsOnly
    });
  }).reduce(function (result, h) {
    var keyValue = {};
    keyValue[h.assetId] = h;
    return Object.assign({}, result, keyValue);
  }, {});
  return _objectSpread(_objectSpread({}, state), {}, {
    loanStatusesByAssetId: _objectSpread(_objectSpread({}, state.loanStatusesByAssetId), loanStatusesByAssetId),
    loading: false,
    error: ''
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_servicingActions.GET_LOAN_STATUS, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  var assetId = action.payload.assetId;
  var loanStatus = state.loanStatusesByAssetId[action.payload.assetId] || {};
  var _action$payload = action.payload,
      _action$payload$profi = _action$payload.profile,
      profile = _action$payload$profi === void 0 ? {} : _action$payload$profi,
      _action$payload$escro = _action$payload.escrowSummary,
      escrowSummary = _action$payload$escro === void 0 ? {} : _action$payload$escro;
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: false,
    loanStatusesByAssetId: _objectSpread(_objectSpread({}, state.loanStatusesByAssetId), {}, (0, _defineProperty2.default)({}, assetId, _objectSpread(_objectSpread({}, loanStatus), {}, {
      borrowerId: action.payload.borrowerId,
      nextDueDate: action.payload.nextDueDate,
      nextPaymentAmount: action.payload.nextPaymentAmount,
      monthlyPaymentAmount: action.payload.monthlyPaymentAmount,
      currentPrincipal: action.payload.currentPrincipal,
      originalPrincipal: action.payload.originalPrincipal,
      currentEscrow: action.payload.currentEscrow,
      currentFees: action.payload.currentFees,
      currentInterest: action.payload.currentInterest,
      totalOwed: action.payload.totalOwed,
      daysLate: action.payload.daysLate,
      isPaymentDue: action.payload.isPaymentDue,
      isPaymentAllowed: action.payload.isPaymentAllowed,
      interestRate: action.payload.interestRate,
      assetId: action.payload.assetId,
      originalTermMonths: action.payload.originalTermMonths,
      remainingTermMonths: action.payload.remainingTermMonths,
      rateType: action.payload.rateType,
      loanType: action.payload.loanType,
      loanNumber: action.payload.loanNumber,
      nextAutopayAmount: action.payload.nextAutopayAmount,
      nextAutopayDate: action.payload.nextAutopayDate,
      nextAutopayLocalDate: action.payload.nextAutopayLocalDate,
      profile: _objectSpread(_objectSpread({}, loanStatus.profile), {}, {
        autopayEnabled: profile.autopayEnabled,
        autopayAmount: profile.autopayAmount,
        autopayAccountUuid: profile.autopayAccountUuid,
        disbursementAccountUuid: profile.disbursementAccountUuid
      }),
      achAccounts: (0, _util.mergeList)(loanStatus.achAccounts, action.payload.achAccounts).map(function (a) {
        return autopayEnabledMapper(a, profile);
      }),
      status: action.payload.status,
      transferred: action.payload.status === 'TRANSFERRED',
      transferData: action.payload.transferData,
      daysSinceTransfer: action.payload.daysSinceTransfer,
      allocations: action.payload.allocations,
      drawEligibility: action.payload.drawEligibility,
      servicerName: action.payload.servicerName,
      escrowSummary: _objectSpread(_objectSpread({}, loanStatus.escrowSummary), {}, {
        currentBalance: escrowSummary.currentBalance,
        currentPayment: escrowSummary.currentPayment,
        escrowDisabled: escrowSummary.escrowDisabled,
        insurance: escrowSummary.insurance,
        taxes: escrowSummary.taxes
      }),
      qualifiedPaymentsOnly: action.payload.qualifiedPaymentsOnly,
      // service-application vars
      uuid: action.payload.assetId,
      amount: action.payload.currentPrincipal,
      rate: action.payload.interestRate,
      term: action.payload.originalTermMonths / 12
    })))
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_servicingActions.SAVE_PAYMENT, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  var assetId = action.meta.assetId;
  var loanStatus = state.loanStatusesByAssetId[assetId] || {};
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: false,
    loanStatusesByAssetId: _objectSpread(_objectSpread({}, state.loanStatusesByAssetId), {}, (0, _defineProperty2.default)({}, assetId, _objectSpread(_objectSpread({}, loanStatus), {}, {
      assetId: assetId,
      transactions: (0, _util.mergeList)(loanStatus.transactions, action.payload.transactions)
    })))
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_servicingActions.GET_TRANSACTIONS, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  var assetId = action.payload.assetId;
  var loanStatus = state.loanStatusesByAssetId[assetId] || {};
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: false,
    loanStatusesByAssetId: _objectSpread(_objectSpread({}, state.loanStatusesByAssetId), {}, (0, _defineProperty2.default)({}, assetId, _objectSpread(_objectSpread({}, loanStatus), {}, {
      assetId: assetId,
      transactions: (0, _util.mergeList)(loanStatus.transactions, action.payload.transactions)
    })))
  });
}), (0, _defineProperty2.default)(_handleActions, (0, _reduxActions.combineActions)("".concat(_servicingActions.GET_ACH_ACCOUNTS, "_").concat(_httpActions.SUCCESS), "".concat(_servicingActions.SAVE_ACH_ACCOUNT, "_").concat(_httpActions.SUCCESS)), function (state, action) {
  var assetId = action.payload.assetId;
  var loanStatus = state.loanStatusesByAssetId[assetId] || {};
  var _loanStatus$profile = loanStatus.profile,
      profile = _loanStatus$profile === void 0 ? {} : _loanStatus$profile; // XXX this assumes end user makes other calls first; can be dangerous!

  return _objectSpread(_objectSpread({}, state), {}, {
    loading: false,
    loanStatusesByAssetId: _objectSpread(_objectSpread({}, state.loanStatusesByAssetId), {}, (0, _defineProperty2.default)({}, assetId, _objectSpread(_objectSpread({}, loanStatus), {}, {
      assetId: assetId,
      achAccounts: (0, _util.mergeList)(loanStatus.achAccounts, action.payload.achAccounts).map(function (a) {
        return autopayEnabledMapper(a, profile);
      })
    })))
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_servicingActions.UPDATE_AUTOPAY, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  var assetId = action.meta.assetId;
  var loanStatus = state.loanStatusesByAssetId[assetId] || {};
  return _objectSpread(_objectSpread({}, state), {}, {
    loanStatusesByAssetId: _objectSpread(_objectSpread({}, state.loanStatusesByAssetId), {}, (0, _defineProperty2.default)({}, assetId, _objectSpread(_objectSpread({}, loanStatus), {}, {
      assetId: assetId,
      profile: _objectSpread(_objectSpread({}, loanStatus.profile), {}, {
        autopayEnabled: action.payload.autopayEnabled,
        autopayAmount: action.payload.autopayAmount,
        autopayAccountUuid: action.payload.autopayAccountUuid,
        disbursementAccountUuid: action.payload.disbursementAccountUuid
      }),
      achAccounts: (loanStatus.achAccounts || []).map(function (a) {
        return autopayEnabledMapper(a, action.payload);
      })
    })))
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_servicingActions.DELETE_ACH_ACCOUNT, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  var assetId = action.meta.assetId; // assuming state is already populated here with loanStatuses.
  // deleting an account is only an option in the UI from the manage accounts screen

  var _ref = state.loanStatusesByAssetId[assetId] || {},
      _ref$profile = _ref.profile,
      profile = _ref$profile === void 0 ? {} : _ref$profile;

  return _objectSpread(_objectSpread({}, state), {}, {
    loanStatusesByAssetId: _objectSpread(_objectSpread({}, state.loanStatusesByAssetId), {}, (0, _defineProperty2.default)({}, assetId, _objectSpread(_objectSpread({}, state.loanStatusesByAssetId[assetId]), {}, {
      achAccounts: (action.payload.achAccounts || []).map(function (a) {
        return autopayEnabledMapper(a, profile);
      })
    })))
  });
}), _handleActions), initialState);
var _default = reducer;
exports.default = _default;